// Tope de convocatorias por UF. El backend (`buscarModulos`) manda en cada fila
// `max_convocatorias`: 5 por defecto y 7 en módulos LOE-2122 (ampliación de la
// Generalitat para el currículum que se extingue). Si no llega (backend antiguo,
// leads, presupuestos) se usa 5, el comportamiento de siempre.

export const MAX_CONVOCATORIAS_BASE = 5;

export const maxConvocatorias = (item) => {
  const max = parseInt(item?.max_convocatorias, 10);
  return Number.isNaN(max) || max <= 0 ? MAX_CONVOCATORIAS_BASE : max;
};

export const convocatoriasAgotadas = (item) =>
  (parseInt(item?.convocatorias, 10) || 0) >= maxConvocatorias(item);
